var map = {
	"./Ash.png": 5390,
	"./Bleached.png": 2418,
	"./Scrubbed.png": 9222,
	"./Teak.png": 1073,
	"./Walnut.png": 8545,
	"./Weathered.png": 2341
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1457;